import { Box, Typography } from '@mui/material'
import {
    AlignType, HeaderType
} from 'src/components/UI/CustomUI/organisms/Table/types'

import styles from './styles.module.scss'

const headers: HeaderType[] = [
  {
    id: 'address',
    label: 'Address',
    custom: true,
    align: 'left' as AlignType,
    Element: (row: any): JSX.Element => {
      return (
        <Box padding="2px 10px">
          <Typography className={styles.Companies__companyName}>
            {row?.address}
          </Typography>
        </Box>
      )
    },
  },
  {
    id: 'status',
    label: 'Status',
    custom: true,
    align: 'left' as AlignType,
    Element: (row: any): JSX.Element => {
      return (
        <Box padding="2px 10px">
          <Typography className={styles.Companies__companyName}>
            {row?.status}
          </Typography>
        </Box>
      )
    },
  },
  {
    id: 'price',
    label: 'Price',
    custom: true,
    align: 'center' as AlignType,
    Element: (row: any): JSX.Element => {
      return (
        <Box padding="2px 10px">
          <Typography className={styles.Companies__companyName}>
            {row?.price}
          </Typography>
        </Box>
      )
    },
  },
]

export default headers
